export const LAYOUT = {
  HEADER_HEIGHT: 80,
  FOOTER_HEIGHT: 48,
  SIDEBAR_WIDTH: 280,
  SIDEBAR_WIDTH_COLLAPSED: 70,
  CONTENT_MAX_WIDTH: 1800,
};
